import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 31000-31999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const mailboxErrors = {
  // 31xxx is the mailbox module's series. Three sites needed no new code — two reused
  // PROJECT_NOT_FOUND and one SESSION_USER_NOT_FOUND (7079), both modulo a trailing period.
  // 31001-31013 — the mailbox module's split.
  MAILBOX_TAGS_CHANGED_ELSEWHERE: {
    errorCode: 31001,
    errorMessage: t("These tags were changed by someone else."),
    isDynamic: false,
  },
  // Distinct from TASK_CUSTOM_FIELDS_VALIDATION_FAILED (17002): same idea, different module.
  MAILBOX_CUSTOM_FIELDS_VALIDATION_FAILED: {
    errorCode: 31002,
    errorMessage: t("Custom Fields validation failed"),
    isDynamic: false,
  },
  MAILBOX_CUSTOM_FIELDS_UPDATE_FAILED: {
    errorCode: 31003,
    errorMessage: t("Failed to update Custom Fields."),
    isDynamic: false,
  },
  MAILBOX_SEND_FAILED: {
    errorCode: 31004,
    errorMessage: t("Error while sending mail."),
    isDynamic: false,
  },
  // The call site's sentence misspells "Acknowledging"; preserved verbatim so the split changes no
  // user-facing text. Worth fixing in a deliberate copy pass, not here.
  MAILBOX_ACKNOWLEDGE_FAILED: {
    errorCode: 31005,
    errorMessage: t("Error while Acknowldeging mail"),
    isDynamic: false,
  },
  MAILBOX_NO_MAILS_FOUND: {
    errorCode: 31006,
    errorMessage: t("No mails found."),
    isDynamic: false,
  },
  MAILBOX_DELETE_FAILED: {
    errorCode: 31007,
    errorMessage: t("Failed to delete selected mails"),
    isDynamic: false,
  },
  MAILBOX_ADD_FAILED: {
    errorCode: 31008,
    errorMessage: t("Error while adding."),
    isDynamic: false,
  },
  MAILBOX_REMOVE_FAILED: {
    errorCode: 31009,
    errorMessage: t("Error while removing."),
    isDynamic: false,
  },
  MAILBOX_PARENT_MAIL_NOT_FOUND: {
    errorCode: 31010,
    errorMessage: t("Parent Mail not found!"),
    isDynamic: false,
  },
  // 31011-31013: the three preconditions for inheriting a parent mail's custom fields.
  MAILBOX_INHERIT_CUSTOM_FIELDS_DISABLED: {
    errorCode: 31011,
    errorMessage: t("Inherit Mail custom fields is disabled"),
    isDynamic: false,
  },
  MAILBOX_DEFAULT_TEMPLATE_REQUIRED: {
    errorCode: 31012,
    errorMessage: t("Please assign a default Mailbox template to Inherit"),
    isDynamic: false,
  },
  MAILBOX_TEMPLATE_DIFFERS_FROM_PARENT: {
    errorCode: 31013,
    errorMessage: t("Current template differs from the parent template"),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
